module.exports = __webpack_public_path__ + "static/media/PlateRate1.d595ae68.jpg";